"use strict";

import { nl2br } from './utils';

export interface CartaoForm {
  id: number | null;
  diagnostico: string;
  ap: string;
  tratamento: string;
  observacoes: string;
  transporte: boolean;
  seguro: number | null | string;
  data_fim_transporte: string | null;
  flag_isento: boolean;
  info_espera: string | null;
}

export interface Icartao{
  id: number;
  id_utente: number;
  activo: number;
  diagnostico: string;
  ap: string | null;
  tratamento: string;
  observacoes: string | null;
  id_seguro: number | null;
  flag_transporte: number;
  data_fim_transporte: string | null;
  flag_isento: boolean;
  info_espera: string | null;
}

export class Cartao {
  private cartaoBD: Icartao;
  constructor(cartao: Icartao) {
    this.cartaoBD = cartao;
  }

  get transporte(): boolean{
    if(this.cartaoBD.flag_transporte) return true;
    else return false;
  }
  get diagnostico(): string{
    if(this.cartaoBD.diagnostico){
      return nl2br(this.cartaoBD.diagnostico, false);
    }
    else {
      return "";
    }
  }

  get tratamento(): string{
    if(this.cartaoBD.tratamento){
      return nl2br(this.cartaoBD.tratamento, false);
    }
    else {
      return "";
    }
  }

  get info_espera(): string{
    if(this.cartaoBD.info_espera){
      return nl2br(this.cartaoBD.info_espera, false);
    }
    else {
      return "";
    }
  }

  get cartaoForm(): CartaoForm{
    const cartao: CartaoForm = {
      id: this.cartaoBD.id,
      ap: this.cartaoBD.ap ? this.cartaoBD.ap : "",
      diagnostico: this.cartaoBD.diagnostico,
      observacoes: this.cartaoBD.observacoes ? this.cartaoBD.observacoes : "",
      seguro: this.cartaoBD.id_seguro,
      transporte: this.cartaoBD.flag_transporte ? true : false,
      tratamento: this.cartaoBD.tratamento,
      data_fim_transporte: this.cartaoBD.data_fim_transporte,
      flag_isento: this.cartaoBD.flag_isento,
      info_espera: this.cartaoBD.info_espera
    };
    return cartao;
  }
}